// extracted by mini-css-extract-plugin
export default {"bell":"BellIcon_bell__re44y","unreadCount":"BellIcon_unreadCount__3JcS4"};